// extracted by mini-css-extract-plugin
export default {"wrap":"_28KeUcQ_sUTzcu3OcuxvUi"};